import React from 'react';
import classnames from 'classnames';
import DropIcon from 'images/icons/logos/drop.svg?react-svg';
import MixingIcon from 'images/icons/logos/mixing.svg?react-svg';
import PinIcon from 'images/icons/logos/pin.svg?react-svg';
import { H2Alt, H3, Paragraph } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import {
  flex,
  column,
  tablet_row,
  centerContent,
  centerItems
} from 'scy/flex.mod.scss';
import { textCenter, plainList } from 'scy/utils.mod.scss';
import { hidden, tablet_block } from 'scy/display.mod.scss';
import { listItem, iconContainer, subtitle } from './styles.mod.scss';

function ValueProps({ id }) {
  return (
    <section
      id={id}
      className={classnames(
        padding.sm,
        padding.tablet_top_lg,
        padding.tablet_bottom_lg,
        textCenter
      )}
    >
      <H2Alt
        marginClass={classnames(margin.top_0, margin.bottom_md)}
        className={classnames(hidden, tablet_block)}
      >
        How to Get Saucey
      </H2Alt>
      <ul
        className={classnames(
          flex,
          column,
          tablet_row,
          centerContent,
          centerItems,
          plainList,
          margin.sides_auto
        )}
      >
        <li className={listItem}>
          <div className={iconContainer}>
            <DropIcon width={60} height={80} />
          </div>
          <H3 marginClass={margin.xs}>The whole liquor store</H3>
          <Paragraph className={subtitle}>
            Fan favorites, seasonal booze, and local picks.
          </Paragraph>
        </li>
        <li className={listItem}>
          <div className={iconContainer}>
            <MixingIcon width={52} height={110} />
          </div>
          <H3 marginClass={margin.xs}>In 30 min</H3>
          <Paragraph className={subtitle}>
            We’re already on our way—no need to get up.
          </Paragraph>
        </li>
        <li className={listItem}>
          <div className={iconContainer}>
            <PinIcon width={60} height={80} />
          </div>
          <H3 marginClass={margin.xs}>At the drop of a pin</H3>
          <Paragraph className={subtitle}>
            We’re outside—Cheers! See you for round two.
          </Paragraph>
        </li>
      </ul>
    </section>
  );
}

export default ValueProps;
